type GermanBookEdition = {
  sourcePath: string;
  title: string;
  amazonAsin?: string;
  authorPage?: string;
  series?: { english: string; german: string };
};

// Titles and original book links come from the Alex Anders Books German records.
const editions: Record<string, GermanBookEdition> = {
  'Serious Trouble': {
    sourcePath: 'www.amazon.com/dp/B08Z22LPN5',
    title: 'Ernsthafte Schwierigkeiten',
    amazonAsin: 'B0929Y13MG',
  },
  'Asking for Trouble': {
    sourcePath: 'www.amazon.com/dp/B09CDZF7YN',
    title: 'Immer Ärger',
    amazonAsin: 'B09BK74DF5',
  },
  'Best Friend Trouble': {
    sourcePath: 'www.amazon.com/dp/B09M5L2L9Q',
    title: 'Ärger unter besten Freunden',
    amazonAsin: 'B09P21FWYJ',
  },
  'Grumpy Boss Trouble': {
    sourcePath: 'www.amazon.com/dp/B0B3SGDXCY',
    title: 'Ärger mit dem Boss',
    amazonAsin: 'B0B4DB7Z2F',
  },
  'Second Chance Trouble': {
    sourcePath: 'www.amazon.com/dp/B0BPJS1JBJ',
    title: 'Schwierigkeiten mit der zweiten Chance',
    amazonAsin: 'B0CRVKKB8C',
  },
  'Mafia Marriage Trouble': {
    sourcePath: 'www.amazon.com/dp/B0BPR45WVB',
    title: 'Mafia Eheprobleme',
    amazonAsin: 'B0BPRBK16Y',
    series: { english: 'Billionaire Mafia', german: 'Mafia-Milliardär-Romanze' },
  },
  "Black Widow's Kiss": {
    sourcePath: 'www.amazon.com/dp/B0DMFWXCWK',
    title: 'Der Kuss der Schwarzen Witwe',
    amazonAsin: 'B0DSKH5GRR',
    series: { english: "Mafia's Submission", german: 'Die Unterwerfung der Mafia' },
  },
  'Bound to the Black Widow': {
    sourcePath: 'www.amazon.com/dp/B0CPXFTCDW',
    title: 'Gefesselt an die Schwarze Witwe',
    amazonAsin: 'B0CPXFYJF8',
    series: { english: "Mafia's Possession", german: 'Im Besitz der Mafia' },
  },
  'The Sheikh Wanted Her Pregnant': {
    sourcePath: 'bit.ly/BB-to-payhip-from-Sheikh-Pregnant',
    title: 'Gezüchtet für das Erbe des Scheichs',
    authorPage: 'https://www.alexandersbooks.com/?pba_book=gezuchtet-fur-das-erbe-des-scheichs',
  },
  'Island Candy': {
    sourcePath: 'bit.ly/Until-Toes-Payhip-from-BB-Island-Candy',
    title: 'Inselzucker',
    amazonAsin: 'B07YS3T6KM',
  },
  'Baby Boy 1-4': {
    sourcePath: 'bit.ly/Baby-Boy-from-BB-to-Payhip',
    title: 'Baby Boy 1-4: Die Sammlung',
    amazonAsin: 'B00KZ651V2',
  },
};

export function localizeCharacterBookLinks(document: Document): void {
  for (const link of Array.from(document.body.querySelectorAll('a[href]'))) {
    const sourceTitle = link.textContent?.match(/\(([^)]+)\)/)?.[1];
    const edition = sourceTitle && editions[sourceTitle];
    if (!edition) continue;

    let sourceUrl: URL;
    try { sourceUrl = new URL(link.getAttribute('href')?.trim() || ''); }
    catch { continue; }
    if (`${sourceUrl.hostname}${sourceUrl.pathname}` !== edition.sourcePath) continue;

    const destination = edition.amazonAsin
      ? `https://www.amazon.de/dp/${edition.amazonAsin}?tag=wwwalexandcom-21`
      : edition.authorPage;
    if (!destination) continue;

    link.setAttribute('href', destination);
    for (const node of Array.from(link.childNodes)) {
      if (node.nodeType !== Node.TEXT_NODE) continue;
      const text = node.textContent || '';
      const titled = text.replace(`(${sourceTitle})`, `(${edition.title})`);
      node.textContent = edition.series
        ? titled.replace(edition.series.english, edition.series.german)
        : titled;
    }
  }
}
